export function kopeikiToRubles(kopeiki: number) {
  return kopeiki / 100
}
